<template>
   <div class="register-section">
       <div class="register-success">
           <img src="../../../assets/images/icon-sucess.png">
           <p>恭喜注册成功！</p>
       </div>
       <Form class="register-result">
            <FormItem v-bind="tailFormItemLayout">
                <div class="register-row">您的登录名为：<span class="phone">{{regInfo.phone}}</span><label>(绑定手机号)</label></div>
            </FormItem>
            <FormItem v-bind="tailFormItemLayout">
                <div class="register-row">绑定邮箱：<span>{{regInfo.email}}</span></div>
            </FormItem>
            <FormItem v-bind="tailFormItemLayout">
                <div class="register-row">昵称：<span>{{regInfo.nickName}}</span></div>
            </FormItem>
            <FormItem v-bind="tailFormItemLayout">
               <Button type="primary" @click="gotoPage('enter')">立即入驻</Button>
               <Button @click="gotoPage('home')">返回门户首页</Button>
            </FormItem>
       </Form>
       <p v-if="!isNc" class="register-tip">若您已经有原系统使用账号，可直接绑定，无需入驻<a @click="gotoPage('accountBindCode')">账号绑定</a></p>
   </div> 
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { Button, Form } from 'ant-design-vue'
import { sessionStore } from '../../../shared/utils';
import { util, jump } from '@utils';

export default {
    data() {
        return {
            isNc: false,
            tailFormItemLayout: {
                wrapperCol: {
                    xs: {
                        span: 24,
                        offset: 0,
                    },
                    sm: {
                        span: 16,
                        offset: 8,
                    },
                },
            },
        }
    },
    computed: {
        ...mapState('register', {
            regInfo: state => state.regInfo
        }),
    },
    async created() {
        this.isNc = util.isNc()
        if (!this.regInfo.phone) {
            const json = sessionStore.getItem('register')
            this.setRegInfo(JSON.parse(json))
        } 
    },
    mounted() {
        util.$tracker(148, '288917',10000);
    },
    methods: {
        ...mapMutations('register', ['setRegInfo']),
        gotoPage(name, toEnter) {
            if (this.isNc) {
                if (name === 'home') {
                    util.jumptoNcHomepage()
                } else if (name === 'enter') {
                    util.jumptoNcEnter()
                }
                return
            }
            if (toEnter) {
                this.$store.commit('pages/home/scrollToId','#ENTER');
            }
            jump.logout(name)
            // if (name === 'accountBindCode') {
            //     jump.logout(name)
            // } else {
            //     this.$router.push({
            //         name
            //     })
            // }
        }
    },
    components: {
        Button,
        Form,
        FormItem: Form.Item,
    }
}
</script>
<style lang="scss" scoped>
.register-success{
    padding-top:20px;
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    text-align: center;

    justify-content: center;


    img{
        width: 20px;
        height: 20px;
    }
    p{
        font-size: 16px;
        font-weight: 700;
        color:#333;
        padding-left:10px;
    }
}
.register-result{
    .register-row{
        font-size: 14px;
        color: #666666;
        line-height: 1;

        span{
            font-size: 14px;
            color: #333333;
        }
        label{
            font-size: 12px;
            color: #999999;
        }
        .phone{
            font-size: 14px;
            color: #FF3A00;
            margin-right: 10px;
        }
    }
    .ant-btn-primary{
        background: #1C7AE5;
        border-radius: 2px;
        width: 130px;
        height: 38px;
        font-size: 14px;
        color: #FFFFFF;
    }
    .ant-btn-default{
        background: #F7F7F7;
        border: 1px solid #DBDBDB;
        border-radius: 2px;
        width: 130px;
        height: 38px;
        font-size: 14px;
        color: #333333;
        margin-left: 20px;
    }

}
.register-tip{
    text-align: center;
    font-size: 14px;
    color:#333;

    a{
        text-decoration: underline;
        padding-left: 10px;
    }
}
</style>
